import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  cardThumbnailCapition: {
    position: 'relative',
    left: '-10px',
    top: '25px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    color: '#2C2D3E',
    '@media (max-width: 1200px)': {
      width: '150px',
      left: '-5px'
    },
    '@media (max-width: 780px)': {
      width: '100px',
      left: '-5px'
    },
  },
  thumbnailContainer: {
    position: 'relative',
    minHeight: '45px'
  },
  actions: {
    position: 'absolute',
    top: '10px',
    right: '15px',
  },
  cardThumbnail: {
    display: 'flex',
    justifyContent: 'center',
    border: 'solid 2px rgba(44, 45, 62, 0.3)',
    borderRadius: '4px',
    margin: '10px',
    color: 'red',
    '@media (max-width: 1200px)': {
      width: '150px !important',
    },
    '@media (max-width: 780px)': {
      width: '80px !important',
    },
  },
  cardThumbnailActive: {
    border: 'solid 2px #3C419A',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
  },
}));
